// In order to keep core.module.ts as small as possible,
// router functionality is kept in this file.

// This is not done with other modules because it is conventient
// to have 'ng generate component' automatically add a component to
// the appropriate module by running it in that directory.

import { RouterModule, Routes } from '@angular/router';
import { QuicklinkStrategy } from 'ngx-quicklink';

import { HomeComponent } from './pages/home/home.component';
import { AuthGuard } from './security/auth.guard';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { Error404Component } from './pages/error404/error404.component';
import { LoginComponent } from './pages/login/login.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { EditUserComponent } from '../administration/users/edit-user/edit-user.component';
import { EditUserModule } from '../administration/users/edit-user/edit-user.module';
import { HelpFilesComponent } from '../help/help-files.component';
import { HelpVideosComponent } from '../help/help-videos/help-videos.component';
import { ReleaseNotesComponent } from './pages/release-notes/release-notes.component';
import { PermissionConst } from './security/generated/Permission';
import { TechSpecComponent } from './pages/tech-spec/tech-spec.component';
import { SilkierHistoryComponent } from 'app/silkier/silkier-history/silkier-history.component';
import { UtilityProvidersListComponent } from '../administration/utility-providers/utility-providers-list/utility-providers-list.component'
import { BillComparisonComponent } from '../forms/bill-comparison/bill-comparison.component';
import { BillComparisonsListComponent } from '../forms/bill-comparisons-list/bill-comparisons-list.component';
import { PublicBillComparisonComponent } from './public/public-bill-comparison/public-bill-comparison.component';
import { ReportComponent } from '../report/report.component'
import { FinancialReportComponent } from '../financial-report/financial-report.component';

// This is the root of our navigation menu route definitions
const routes: Routes = [
	{ path: '', component: HomeComponent, pathMatch: 'full' },
	{ path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
	{ path: 'login', component: LoginComponent },
	{ path: 'release-notes', component: ReleaseNotesComponent, canActivate: [AuthGuard] },
	{ path: 'edit-user/:id', component: EditUserComponent, canActivate: [AuthGuard] },
	{ path: 'forgot-password', component: ForgotPasswordComponent },
	{ path: 'change-password/:id', component: ChangePasswordComponent },
	{ path: 'tech-spec', component: TechSpecComponent, canActivate: [AuthGuard] },
	{ path: 'quartz/history/pcg', component: SilkierHistoryComponent , canActivate: [AuthGuard]},
	{ path: 'public-bill-comparison', component: PublicBillComparisonComponent },
	{ 
		path: 'reports/monthly-bill-comparison',
		component: ReportComponent, 
		canLoad: [AuthGuard],
	},
	{ 
		path: 'reports/financial',
		component: FinancialReportComponent, 
		canLoad: [AuthGuard],
	},
	// tslint:disable-next-line:max-line-length
	{
		path: 'administration',
		canLoad: [AuthGuard],
		loadChildren: () => import('../administration/administration.module').then(m => m.AdministrationModule),
	},
	{
		path: 'help',
		canActivate: [AuthGuard],
		component: HelpFilesComponent,
		data: { security: PermissionConst.coreFeatures },
	},
	// tslint:disable-next-line:max-line-length
	{
		path: 'help/help-video/:id',
		canActivate: [AuthGuard],
		component: HelpVideosComponent,
		data: { security: PermissionConst.coreFeatures },
	},
	{
		path: 'pcg-forms',
		canLoad: [AuthGuard],
		loadChildren: () => import('../forms/pcg-forms.module').then(m => m.PcgFormsModule)
	},
	{ path: '**', redirectTo: '' },
];

export class CoreRouting {
	static declarations = [
		HomeComponent,
		DashboardComponent,
		LoginComponent,
		Error404Component,
		ForgotPasswordComponent,
		ChangePasswordComponent,
		HelpFilesComponent,
		HelpVideosComponent,
		SilkierHistoryComponent,
		ReportComponent,
		FinancialReportComponent
	];
	// tslint:disable-next-line:max-line-length
	static imports = [
		RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    preloadingStrategy: QuicklinkStrategy
}),
		EditUserModule,
	];
	static exports = [RouterModule];
	static providers = [AuthGuard];
}
